<template>
  <main>
    <!-- Header + Points -->
    <div class="pricing-header">
      <div class="header-title">Pricing</div>
      <div class="header-subtitle">easy as</div>

      <div class="points">
        <div class="points-item">
          <img
            src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
            height="15"
            width="15"
          />
          <span>Guaranteed no hidden costs</span>
        </div>
        <div class="points-item">
          <img
            src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
            height="15"
            width="15"
          />
          <span>On time completion</span>
        </div>
        <div class="points-item">
          <img
            src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
            height="15"
            width="15"
          />
          <span>Reduce your tax</span>
        </div>
      </div>
    </div>

    <!-- Business Pricing -->
    <section class="pricing-section blue">
      <div class="section-title">Business Owners</div>
      <div class="table">
        <!-- Non-GST Registered -->
        <div class="table-item">
          <div class="plan-title">Non-GST Registered</div>
          <div class="plan-price">$90<span>.00</span></div>
          <div class="plan-subtext">NZD per month excluding GST</div>
          <div class="plan-description">
            Non-GST registered businesses, sole traders & partnerships
          </div>
          <div class="table-item-features">
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Financial statements</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Up to 3 tax returns</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Tax minimization</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Tax planning & management</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Unlimited advice</span>
            </div>
            <div class="feature feature-disabled">
              <svg
                height="13px"
                width="13px"
                viewBox="0 0 329.26933 329"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g fill="rgba(33, 59, 85, 0.5)">
                  <path
                    d="m21.339844 329.398438c-5.460938 0-10.925782-2.089844-15.082032-6.25-8.34375-8.339844-8.34375-21.824219 0-30.164063l286.589844-286.59375c8.339844-8.339844 21.824219-8.339844 30.164063 0 8.34375 8.339844 8.34375 21.824219 0 30.164063l-286.589844 286.59375c-4.183594 4.179687-9.621094 6.25-15.082031 6.25zm0 0"
                  />
                  <path
                    d="m307.929688 329.398438c-5.460938 0-10.921876-2.089844-15.082032-6.25l-286.589844-286.59375c-8.34375-8.339844-8.34375-21.824219 0-30.164063 8.339844-8.339844 21.820313-8.339844 30.164063 0l286.589844 286.59375c8.34375 8.339844 8.34375 21.824219 0 30.164063-4.160157 4.179687-9.621094 6.25-15.082031 6.25zm0 0"
                  />
                </g>
              </svg>
              <span>GST Returns</span>
            </div>
          </div>
          <a href="/contact" class="btn-talk">Lets talk</a>
        </div>

        <!-- GST Registered -->
        <div class="table-item">
          <div class="plan-title">GST Registered</div>
          <div class="plan-price">$115<span>.00</span></div>
          <div class="plan-subtext">NZD per month excluding GST</div>
          <div class="plan-description">
            GST registered businesses that do their own GST returns
          </div>
          <div class="table-item-features">
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Financial statements</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Up to 3 tax returns</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Tax minimization</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Tax planning & management</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Unlimited advice</span>
            </div>
            <div class="feature feature-disabled">
              <svg
                height="13px"
                width="13px"
                viewBox="0 0 329.26933 329"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g fill="rgba(33, 59, 85, 0.5)">
                  <path
                    d="m21.339844 329.398438c-5.460938 0-10.925782-2.089844-15.082032-6.25-8.34375-8.339844-8.34375-21.824219 0-30.164063l286.589844-286.59375c8.339844-8.339844 21.824219-8.339844 30.164063 0 8.34375 8.339844 8.34375 21.824219 0 30.164063l-286.589844 286.59375c-4.183594 4.179687-9.621094 6.25-15.082031 6.25zm0 0"
                  />
                  <path
                    d="m307.929688 329.398438c-5.460938 0-10.921876-2.089844-15.082032-6.25l-286.589844-286.59375c-8.34375-8.339844-8.34375-21.824219 0-30.164063 8.339844-8.339844 21.820313-8.339844 30.164063 0l286.589844 286.59375c8.34375 8.339844 8.34375 21.824219 0 30.164063-4.160157 4.179687-9.621094 6.25-15.082031 6.25zm0 0"
                  />
                </g>
              </svg>
              <span>GST Returns</span>
            </div>
          </div>
          <a href="/contact" class="btn-talk">Lets talk</a>
        </div>

        <!-- GST Returns Done by Us -->
        <div class="table-item">
          <div class="plan-title">GST Returns</div>
          <div class="plan-price">$155<span>.00</span></div>
          <div class="plan-subtext">NZD per month excluding GST</div>
          <div class="plan-description">
            GST registered businesses that want GST returns done by us
          </div>
          <div class="table-item-features">
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Financial statements</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Up to 3 tax returns</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Tax minimization</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Tax planning & management</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Unlimited advice</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>GST Returns</span>
            </div>
          </div>
          <a href="/contact" class="btn-talk">Lets talk</a>
        </div>
      </div>
    </section>

    <!-- Property Pricing -->
    <section class="pricing-section green">
      <div class="section-title">Property Investors</div>
      <div class="table">
        <!-- One Property -->
        <div class="table-item">
          <div class="plan-title">One Property</div>
          <div class="plan-price">$75<span>.00</span></div>
          <div class="plan-subtext">NZD per month excluding GST</div>
          <div class="plan-description">Investors with one property</div>
          <div class="table-item-features">
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Financial statements</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Up to 3 tax returns</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Tax minimization</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Tax planning & management</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Unlimited advice</span>
            </div>
          </div>
          <a href="/contact" class="btn-talk">Lets talk</a>
        </div>

        <!-- Two - Three Properties -->
        <div class="table-item">
          <div class="plan-title">Two - Three Properties</div>
          <div class="plan-price">$90<span>.00</span></div>
          <div class="plan-subtext">NZD per month excluding GST</div>
          <div class="plan-description">Investors with two - three properties</div>
          <div class="table-item-features">
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Financial statements</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Up to 3 tax returns</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Tax minimization</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Tax planning & management</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Unlimited advice</span>
            </div>
          </div>
          <a href="/contact" class="btn-talk">Lets talk</a>
        </div>

        <!-- Four Plus Properties -->
        <div class="table-item">
          <div class="plan-title">Four Plus Properties</div>
          <div class="plan-price">$115<span>.00</span></div>
          <div class="plan-subtext">NZD per month excluding GST</div>
          <div class="plan-description">Investors with four or more properties</div>
          <div class="table-item-features">
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Financial statements</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Up to 3 tax returns</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Tax minimization</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Tax planning & management</span>
            </div>
            <div class="feature">
              <img
                src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg"
                height="15"
                width="15"
              /><span>Unlimited advice</span>
            </div>
          </div>
          <a href="/contact" class="btn-talk">Lets talk</a>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="cta-section">
      <div class="cta-title">Experience the Slater difference</div>
      <div class="cta-subtitle">Too busy to come to us? We can come to you!</div>
      <a href="/contact" class="cta-btn">Lets talk</a>
    </section>
  </main>
</template>

<script setup>
document.title = 'Pricing - Slater';
</script>

<style scoped>
/* ===== PRICING HEADER ===== */
.pricing-header {
  margin: 100px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.header-title {
  margin-bottom: 30px;
  font-size: 72px;
  font-weight: 600;
  color: #213b55;
  line-height: 1.1;
}

.header-subtitle {
  margin-bottom: 30px;
  font-size: 27px;
  color: #213b55;
  font-weight: 400;
}

.points {
  display: flex;
  font-size: 18px;
  color: #213b55;
  gap: 30px;
  flex-wrap: wrap;
  justify-content: center;
}

.points-item {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* ===== PRICING SECTIONS ===== */
.pricing-section {
  margin: 100px 2vw 0;
  display: flex;
  flex-direction: column;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 0 0;
  font-size: 32px;
  font-weight: 600;
  color: #213b55;
}

/* ===== PRICING TABLE ===== */
.table {
  display: flex;
  flex-wrap: wrap;
  padding: 70px 100px 150px;
  gap: 30px;
  justify-content: center;
}

.table-item {
  flex: 1 1 25%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.table-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

/* ===== PLAN TITLES ===== */
.plan-title {
  font-size: 21px;
  font-weight: 600;
  color: #213b55;
  text-align: center;
  margin-bottom: 15px;
}

.plan-price {
  font-size: 72px;
  font-weight: 600;
  color: #213b55;
  text-align: center;
}

.plan-price span {
  font-size: 32px;
}

.plan-subtext {
  text-align: center;
  margin-top: 10px;
  color: #213b55;
  font-weight: 400;
}

.plan-description {
  text-align: center;
  margin-top: 20px;
  padding: 0 20px;
  color: #213b55;
  line-height: 1.5;
}

/* ===== FEATURES LIST ===== */
.table-item-features {
  margin-top: 50px;
  margin-bottom: 50px;
  font-size: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature {
  display: flex;
  align-items: center;
  gap: 20px;
  color: #213b55;
}

.feature svg {
  min-width: 13px;
}

.feature-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ===== BUTTONS ===== */
.btn-talk,
.cta-btn {
  font-size: 17px;
  font-weight: 600;
  height: 40px;
  padding: 5px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #183043;
  background-color: #50dcaa;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.btn-talk:hover,
.cta-btn:hover {
  background-color: #3bcf91;
  transform: translateY(-2px);
}

/* ===== CTA SECTION ===== */
.cta-section {
  margin: 200px 2vw;
  display: flex;
  flex-direction: column;
  background-color: #bbf3fd;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  padding: 50px 20px;
  text-align: center;
}

.cta-title {
  font-size: 51px;
  font-weight: 600;
  color: #213b55;
  margin-top: 50px;
  padding: 10px;
}

.cta-subtitle {
  font-size: 27px;
  color: #213b55;
  margin-top: 10px;
}

.cta-btn {
  margin-top: 50px;
  margin-bottom: 50px;
  max-width: 200px;
  font-size: 20px;
  background-color: #213b55;
  color: #fff;
  border-radius: 4px;
}

/* ===== BACKGROUND COLORS ===== */
.blue {
  background-color: #bbf3fd;
}

.green {
  background-color: #6fefc1;
}

/* ===== RESPONSIVE ===== */
@media only screen and (max-width: 1024px) {
  .table-item {
    flex: 1 1 45%;
  }
}

@media only screen and (max-width: 768px) {
  .header-title {
    font-size: 50px;
    margin-bottom: 15px;
  }
  .points {
    flex-direction: column;
    gap: 15px;
  }
  .table {
    flex-direction: column;
    padding: 70px 20px 50px;
  }
  .table-item {
    width: 100%;
    margin-bottom: 50px;
  }
}

@media only screen and (max-width: 480px) {
  .header-title {
    font-size: 42px;
    margin-bottom: 10px;
  }
  .header-subtitle {
    font-size: 22px;
    margin-bottom: 10px;
  }
  .table-item {
    padding: 40px 20px;
  }
  .plan-price {
    font-size: 50px;
  }
  .plan-price span {
    font-size: 24px;
  }
  .cta-title {
    font-size: 38px;
  }
  .cta-subtitle {
    font-size: 22px;
  }
}
</style>
